import { useState } from 'react';

// const INITIAL_VIEW_STATE = {
//   reportParameters: {
//     orgUnitId: 1915
//   },
//   routeName: 'USA_SWIMMING_HQ_CLUB_TIMES'
// };

const INITIAL_VIEW_STATE = {
  reportParameters: {},
  routeName: 'USA_SWIMMING_HQ_CLUB_TIMES'
};

const useDynamicClubReport = () => {
  const [viewState, setViewState] = useState({ ...INITIAL_VIEW_STATE });

  return { ...viewState };
};

export default useDynamicClubReport;